"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Shield, Cpu, Building2, Building, Factory, Hotel, HardHat, Sun, Zap, Target, Leaf } from "lucide-react";
export default function BenefitsAndTechnology() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const benefits = [{
    icon: Zap,
    label: "Más rápido y eficiente",
    description: "Gracias al uso de drones, los tiempos de limpieza se reducen entre 5 y 10 veces frente a los métodos tradicionales, optimizando recursos y tiempos de ejecución."
  }, {
    icon: Shield,
    label: "Reducción de riesgos",
    description: "La limpieza con drones elimina los riesgos asociados a trabajos en altura, reduciendo costos logísticos, trámites y mejorando la seguridad operativa."
  }, {
    icon: Target,
    label: "Acceso a las zonas más difíciles",
    description: "Los drones permiten acceder y limpiar áreas de difícil alcance en naves industriales, fábricas, hoteles, oficinas y edificios residenciales."
  }, {
    icon: Cpu,
    label: "Tecnología avanzada",
    description: "Drones de última generación integrados con equipos profesionales de limpieza industrial, diseñados para maximizar precisión, potencia y resultados."
  }, {
    icon: Leaf,
    label: "Menor impacto ambiental",
    description: "El uso de drones reduce el consumo de agua, energía y recursos, disminuyendo el impacto ambiental frente a otros métodos de limpieza."
  }];
  const industries = [{
    icon: Building2,
    label: "Edificios corporativos"
  }, {
    icon: Building,
    label: "Torres residenciales"
  }, {
    icon: Factory,
    label: "Instalaciones industriales"
  }, {
    icon: Hotel,
    label: "Hoteles"
  }, {
    icon: HardHat,
    label: "Obras en construcción"
  }, {
    icon: Sun,
    label: "Paneles solares"
  }];
  return <section ref={ref} className="bg-background py-16 px-6 md:px-12 lg:px-24">
      <div className="mx-auto max-w-7xl">
        <div className="flex justify-center">
          <div className="w-full max-w-3xl space-y-4">
            {benefits.map((benefit, i) => {
            const Icon = benefit.icon;
            return <div key={i} data-index={i} className={`flex items-center gap-4 ${isVisible ? "animate-fade-in-up" : "opacity-0"}`} style={{
              animationDelay: isVisible ? `${i * 100}ms` : "0ms"
            }}>
                  <div className="flex-shrink-0 w-14 h-14 bg-primary/10 rounded-lg flex items-center justify-center">
                    <Icon className="w-7 h-7 text-primary" strokeWidth={2} />
                  </div>
                  <div className="flex-1">
                    <p className="text-foreground text-xl font-semibold font-display">
                      {benefit.label}
                    </p>
                    {benefit.description && <p className="text-base text-muted-foreground mt-1">
                        {benefit.description}
                      </p>}
                  </div>
                </div>;
          })}
          </div>
        </div>

        {}
        <div className="mt-16">
          <h3 className="text-2xl font-bold font-display text-foreground text-center mb-8">
            Industrias que servimos
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
            {industries.map((industry, i) => {
            const Icon = industry.icon;
            return <div key={i} data-index={i} className={`flex flex-col items-center gap-3 ${isVisible ? "animate-fade-in-up" : "opacity-0"}`} style={{
              animationDelay: isVisible ? `${(i + 5) * 100}ms` : "0ms"
            }}>
                  <div className="w-16 h-16 bg-secondary/10 rounded-lg flex items-center justify-center hover:-translate-y-1 hover:shadow-strong transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
                    <Icon className="w-8 h-8 text-secondary" strokeWidth={2} />
                  </div>
                  <p className="text-foreground text-sm font-medium text-center">
                    {industry.label}
                  </p>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}